var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid d-flex flex-wrap justify-content-between"},[_vm._m(0),_c('div',{staticClass:"copyright"},[_vm._v(" © "+_vm._s(_vm.year)+", CP Hub LLC. ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('ul',{staticClass:"footer-menu"})])
}]

export { render, staticRenderFns }